export default "/dist/fonts/RobotoCondensed-Regular.ttf";